import { render, staticRenderFns } from "./DoctorTem.vue?vue&type=template&id=76e121ec&scoped=true"
import script from "./DoctorTem.vue?vue&type=script&lang=js"
export * from "./DoctorTem.vue?vue&type=script&lang=js"
import style0 from "./DoctorTem.vue?vue&type=style&index=0&id=76e121ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e121ec",
  null
  
)

export default component.exports